// src/pages/Login.js
import {
  LockOutlined,
  UserOutlined,
  GoogleOutlined,
  FacebookOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Typography,
  Divider,
} from "antd";
import { useNavigate } from "react-router-dom";
import client from "../helpers/directusClient";
import React, { useState, useContext } from "react";
import { AppContext } from "../context/AppContext";
import { readMe } from "@directus/sdk";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

const Clientlogin = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { setUser, setCompany, setCards, setMenus, updateBalance } =
    useContext(AppContext);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Logs in
      const user = await client.login(values.email, values.password);
      console.log("Auth response:", user);

      // Retrieve user details with role name
      const me = await client.request(
        readMe({
          fields: [
            "id, email, first_name, last_name, role.name, role.id, phone, nrc, address, credit_score, company.id, company.company_name, loans.loan_transactions.*",
          ],
        })
      );

      console.log("User details:", me);

      // Set user data in context (this updates AppContext state)
      setUser({
        user_id: me.id,
        name: `${me.first_name} ${me.last_name}`,
        first_name: me.first_name,
        last_name: me.last_name,
        email: me.email,
        role: me.role.name,
        phone: me.phone,
        nrc: me.nrc,
        address: me.address,
        credit_score: me.credit_score,
        loans: me.loans,
      });

      // Set any company info if available
      if (me.company) {
        setCompany(me.company);
      }

      // Calculate token expiration time
      const expirationTime = Date.now() + user.expires;

      // Store authentication data in localStorage - THIS IS CRUCIAL
      localStorage.setItem("isAuth", "true");
      localStorage.setItem("userRole", me.role.name); // Use the role name, not ID
      localStorage.setItem("token", user.access_token);
      localStorage.setItem("expires", expirationTime);

      // The user object will be stored via the AppContext useEffect
      // (see src/context/AppContext.js lines 91-98)

      setLoading(false);

      // Navigate to borrower profile
      navigate("/borrowerProfile");
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      message.error(
        "Login failed. Please check your credentials and try again."
      );
    }
  };

  return (
    <Row
      justify="center"
      align="middle"
      style={{
        height: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "0 15px",
      }}
    >
      <Col xs={24} sm={20} md={16} lg={12} xl={8}>
        <Card
          hoverable
          style={{
            borderRadius: 12,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
          }}
          bodyStyle={{
            padding: "40px 32px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            {/* Add your company logo here */}
            {/* <img
                src="/logo.png"
                alt="Company Logo"
                style={{
                  height: 64,
                  marginBottom: 24,
                  borderRadius: 8,
                }}
              /> */}
            <Title level={2} style={{ marginBottom: 8, color: "#2D3748" }}>
              Welcome Back
            </Title>
            <Text type="secondary" style={{ fontSize: 14 }}>
              Please sign in to continue
            </Text>
          </div>

          <Form
            name="loginForm"
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
            initialValues={{ remember: true }}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter your email." }]}
              style={{ marginBottom: 24 }}
            >
              <Input
                autoComplete="off"
                prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                placeholder="Enter email"
                size="large"
                style={{ borderRadius: 8 }}
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              autoComplete="off"
              rules={[
                { required: true, message: "Please enter your password." },
              ]}
              style={{ marginBottom: 24 }}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                placeholder="Enter password"
                size="large"
                style={{ borderRadius: 8 }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 16 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={loading}
                style={{
                  height: 48,
                  borderRadius: 8,
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  fontWeight: 600,
                }}
              >
                Sign In
              </Button>
            </Form.Item>

            <div style={{ textAlign: "center", marginBottom: 24 }}>
              <Link
                to="/forgot-password"
                style={{
                  color: "#667eea",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                Forgot Password?
              </Link>
            </div>
            {/* 
              <Divider style={{ color: "#A0AEC0", fontSize: 12 }}>
                OR CONTINUE WITH
              </Divider> */}

            {/* <Row gutter={16} style={{ marginTop: 24 }}>
                <Col span={12}>
                  <Button
                    block
                    size="large"
                    style={{
                      height: 44,
                      borderRadius: 8,
                      background: "#F8F9FA",
                      color: "#2D3748",
                      fontWeight: 500,
                    }}
                    icon={<GoogleOutlined />}
                  >
                    Google
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    block
                    size="large"
                    style={{
                      height: 44,
                      borderRadius: 8,
                      background: "#F8F9FA",
                      color: "#2D3748",
                      fontWeight: 500,
                    }}
                    icon={<FacebookOutlined />}
                  >
                    Facebook
                  </Button>
                </Col>
              </Row> */}

            <div style={{ textAlign: "center", marginTop: 32 }}>
              <Text type="secondary" style={{ fontSize: 14 }}>
                Don't have an account?{" "}
                <Link
                  to={"/clientsignup"}
                  style={{
                    color: "#667eea",
                    fontWeight: 500,
                  }}
                >
                  Create Account
                </Link>
              </Text>
            </div>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default Clientlogin;
